import { MESSAGES_TO_SM, REDUCERS } from '../../constants.js';
import {
	messageNoAvailable,
	messageRetryFirstCall,
	messageAgentRedy,
	messageToSupervisor,
	messageChangeStateHelper,
	messageStartStopRecording,
	messageSaveMarksSM,
	messageApiRequest,
	updateInfoCall,
	messageTransferCall,
	messageAssistedTransferCall,
	manualCall,
	messageHangUp,
	messageOngoingCallIvr,
	endConversationChat,
	aceptedChat,
	spamConversation,
	unassignConversation,
	discardConversation,
	sendUnifiedResponse,
	sendDisposition,
	selectedMessage,
	sendMessageToExternalMU,
	changeState,
	closeUnified,
	SetAgentDialingMode,
	PreviewRecord,
	messagePreviewTransfer,
	responsePreviewTransfer,
	acceptChatSaveTime,
	GetMoreMessages,
	changeMultimediaState,
	messageApiRequestANIList,
	messageGetPreviewCampaigns,
	GetRecordCallPermission
} from '../../js/helpers/helperMessages';


const initialMessageState = {
	reducer_type: REDUCERS.REDUCER_ACTIOS_FROM_SM,
	message: null
};

const messagesToSM = (state = initialMessageState, action) => {
	switch (action.type) {
		case MESSAGES_TO_SM.MESSAGE_TO_SM:
			return { message: action.message };
		case MESSAGES_TO_SM.NO_AVAILABLE_EVENT:
			const messageNoAvailble = messageNoAvailable(action.userName, action.userID, action.notReadyID, action.conversationID, action.TimePreview);
			return { message: messageNoAvailble };
		case MESSAGES_TO_SM.RETRY_FIRST_CALL:
			const messageRetry = messageRetryFirstCall(action.userName, action.userID, action.notReadyID);
			return { message: messageRetry };
		case MESSAGES_TO_SM.AGENT_READY:
			const messageRedy = messageAgentRedy();
			return { message: messageRedy };
		case MESSAGES_TO_SM.MESSAGE_TO_SUPERVISOR:
			const messageTosup = messageToSupervisor(action.message, action.supervisor);
			return { message: messageTosup };
		case MESSAGES_TO_SM.CHANGE_STATE:
			const messageChangeState = messageChangeStateHelper();
			return { message: messageChangeState };
		case MESSAGES_TO_SM.START_STOP_RECORDING:
			const messageStartStopRec = messageStartStopRecording(action.isStop, action.callOutId);
			return { message: messageStartStopRec };
		case MESSAGES_TO_SM.MARKS_CALL:
			const messageSaveMarks = messageSaveMarksSM(action.marks, action.callOutId);
			return { message: messageSaveMarks };
		case MESSAGES_TO_SM.API_REQUEST:
			const apiRequest = messageApiRequest(action.subaction, action.json, action.expectsResponse, action.callOutId);
			return { message: apiRequest };
		case MESSAGES_TO_SM.UPDATE_DATA_CALL:
			const messageUpdate = updateInfoCall(action.callKey, action.camId, action.dataCall, action.CallOutId);
			return { message: messageUpdate };
		case MESSAGES_TO_SM.TRANSFER_CALL:
			const messageTransfer = messageTransferCall(action.data);
			return { message: messageTransfer };
		case MESSAGES_TO_SM.ASSISTED_TRANSFER_CALL:
			const messageAssistedTransfer = messageAssistedTransferCall(action.process, action.data);
			return { message: messageAssistedTransfer };
		case MESSAGES_TO_SM.MANUAL_CALL:
			const manualCallaObject = manualCall(action.data);
			return { message: manualCallaObject };
		case MESSAGES_TO_SM.HANG_UP:
			const hangUpObject = messageHangUp(action.subaction,action.callOutId,action.calloutMaxTime);
			return { message: hangUpObject };
		case MESSAGES_TO_SM.ONGOING_CALL_IVR:
			const ongoingCallIvrObject = messageOngoingCallIvr(action.id);
			return { message: ongoingCallIvrObject };
		case MESSAGES_TO_SM.END_CONVERSATION_CHAT:
			const endConversationObject = endConversationChat(action.data);
			return { message: endConversationObject };
		case MESSAGES_TO_SM.ACEPTED_CHAT:
			const aceptedChatObject = aceptedChat(action.data);
			return { message: aceptedChatObject };
		case MESSAGES_TO_SM.SPAM_CONVERSATION:
			const onSpamConversationObject = spamConversation(action.data);
			return { message: onSpamConversationObject };
		case MESSAGES_TO_SM.UNASSIGN_CONVERSATION:
			const unassignConversationObject = unassignConversation(action.data);
			return { message: unassignConversationObject };
		case MESSAGES_TO_SM.DISCARD_CONVERSATION:
			const discardConversationObject = discardConversation(action.data);
			return { message: discardConversationObject };
		case MESSAGES_TO_SM.SELECTED_MESSAGE:
			const selectedMessageObject = selectedMessage(action.data);
			return { message: selectedMessageObject };
		case MESSAGES_TO_SM.SEND_DISPOSITION:
			const sendDispositionObject = sendDisposition(action.data);
			return { message: sendDispositionObject };
		case MESSAGES_TO_SM.SEND_UNIFIED_RESPONSE:
			const sendUnifiedResponseObject = sendUnifiedResponse(action.data);
			return { message: sendUnifiedResponseObject };
		case MESSAGES_TO_SM.SEND_EXTERNAL_UNIFIED_RESPONSE:
			const sendExternalUnifiedResponseObject = sendMessageToExternalMU(action.data);
			return { message: sendExternalUnifiedResponseObject };
		case MESSAGES_TO_SM.CHANGE_STATE_MULTIMEDIA:
			const changeStateObject = changeState(action.data);
			return { message: changeStateObject };
		case MESSAGES_TO_SM.CHANGE_STATE_MULTIMEDIA_ALL:
			const changeStateObjectEmail = changeMultimediaState(action.data);
			return { message: changeStateObjectEmail };
		case MESSAGES_TO_SM.CHANGE_DIALINGMODE_SCH:
			const setAgentDialingMode = SetAgentDialingMode(action.data);
			return {message: setAgentDialingMode};
		case MESSAGES_TO_SM.PREVIEW_RECORD:
			const previewRecord = PreviewRecord(action.data);
			return {message:previewRecord};
		case MESSAGES_TO_SM.PREVIEW_TRANSFER:
			const previewTransfer = messagePreviewTransfer(action.subaction, action.agent, action.callOutId);
			return {message:previewTransfer}
		case MESSAGES_TO_SM.SEND_RESPONSE_TRANSFER:
			const responsepreviewTransfer = responsePreviewTransfer(action.agent, action.response);
			return {message:responsepreviewTransfer}
		case MESSAGES_TO_SM.GET_MORE_MESSAGES:
			const getMoreMessagesObject = GetMoreMessages(action.data);
			return {message:getMoreMessagesObject}
		case MESSAGES_TO_SM.ACCEPT_CHAT_SAVE_TIME:
			const acceptChatSaveTimeObj = acceptChatSaveTime(action.data);
			return { message: acceptChatSaveTimeObj };
		case MESSAGES_TO_SM.API_REQUEST_ANI_LIST:
			const appiRequest = messageApiRequestANIList(action.subaction, action.campId, action.expectsResponse)
			return { message: appiRequest };
		case MESSAGES_TO_SM.GET_RECORD_CALL_PERMISSION:
			const recordRequest = GetRecordCallPermission(action.subaction, action.campId, action.expectsResponse)
			return { message: recordRequest };
		case MESSAGES_TO_SM.GET_PREVIEW_CAMPAIGNS:
			const previewCampaigns = messageGetPreviewCampaigns('GetPreviewCampaigns')
			return { message: previewCampaigns };
		default:
			return state;
	}
};

export default messagesToSM;



// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_messages_to_SM.js